import { css } from '@emotion/css';

const styles = {
  container: css`
    position: relative;
    width: 100%;
    aspect-ratio: 8.5 / 11;
    display: flex;
    height: 100%;
  `,
  image: css`
    display: block;
    width: 100%;
    aspect-ratio: 8.5 / 11;
  `,
  dimmed: css`
    opacity: 0;
  `,
  overlay: css`
    position: absolute;
    left: 0;
    top: 0;
  `,
  link: css`
    position: absolute;
    cursor: pointer;
  `,
  expiredFlyerOverlay: css`
    opacity: 0.3;
  `,
  pendingFlyerOverlay: css`
    opacity: 0.1;
  `,
  hideDimmedFlyer: css`
    display: none;
  `,
};

export default styles;
